export const SPECIALTYMAPPING = {
    1: "Endocrinology, Metabolism",
    2: "Endocrinology, Reproductive / Infertility",
    3: "Case Management / Discharge Planning",
    4: "Faculty / Teaching",
    5: "Correctional Health",
    6: "Home Care",
    7: "Forensics",
    10: "Infusion Therapy",
    12: "Patient Education",
    15: "Quality Management",
    16: "Wound / Ostomy",
    18: "Risk Management / Utilization Review",
    26: "Administration / Management",
    30: "Anesthesiology",
    32: "Cardiology, General",
    34: "Aerospace Medicine",
    35: "Dermatology, General",
    36: "Emergency Medicine",
    37: "Dermatology, Cosmetic",
    38: "Family Medicine",
    39: "Gastroenterology",
    40: "General Practice",
    41: "Hematology",
    42: "Infectious Diseases",
    43: "Internal Medicine",
    45: "Allergy & Clinical Immunology",
    47: "Neurology",
    49: "Ob/Gyn & Women's Health",
    51: "Oncology, Medical",
    52: "Ophthalmology",
    53: "Blood Banking / Transfusion Medicine",
    56: "Otolaryngology",
    57: "Pathology",
    59: "Cardiology, Electrophysiology",
    60: "Pediatrics, General",
    61: "Psychiatry / Mental Health",
    65: "Rheumatology",
    67: "Radiology, Interventional",
    70: "Urology",
    76: "HIV/AIDS",
    77: "Addiction Medicine",
    79: "Epidemiology",
    80: "Geriatrics",
    84: "Preventive Medicine",
    96: "Diabetes Educator",
    111: "Diabetes",
    121: "Hepatology",
    122: "Hospice / Palliative Care",
    140: "Transplantation",
    146: "Vascular Medicine",
    156: "Radiology",
    160: "Research",
    162: "School / College Health",
    166: "Sleep Medicine",
    168: "Sports Medicine",
    174: "Medical Microbiology",
    185: "Genomic Medicine",
    194: "Nutrition",
    195: "Nutrition Support",
    198: "Occupational Health",
    203: "Oncology, Hematology / Oncology",
    204: "Nephrology",
    205: "Nuclear Medicine",
    207: "Orthopaedic Surgery",
    208: "Other Clinical",
    209: "Physical Medicine & Rehabilitation",
    213: "Oncology",
    229: "Legal Consulting",
    263: "Pharmacotherapy",
    264: "Plastic Surgery & Aesthetic Medicine",
    270: "Psychiatry",
    277: "Medical Genetics",
    284: "Adolescent Medicine",
    285: "Cardiology, Interventional",
    287: "Critical Care / Intensive Care",
    288: "Public / Community Health",
    292: "Medical Toxicology",
    293: "Molecular Medicine",
    294: "Neonatal / Perinatal Medicine",
    295: "Neurosurgery",
    298: "Oncology, Radiation",
    299: "Surgery, Surgical Oncology",
    302: "Pain Management",
    306: "Pulmonary Medicine",
    317: "Surgery, Cardiothoracic",
    321: "Surgery, General",
    322: "Surgery, Oral & Maxillofacial",
    327: "Surgery, Vascular",
    332: "Cardiology, Echocardiography",
    333: "Cardiology, Nuclear",
    334: "Oncology, Other",
    335: "Pediatrics, Allergy",
    336: "Pediatrics, Cardiology",
    337: "Pediatrics, Oncology",
    338: "Surgery, Other",
    339: "Other Clinical",
    340: "Non-Clinical",
    341: "Anticoagulation",
    342: "Cardiology",
    343: "Compounding",
    344: "Critical Care",
    349: "Veterinary Medicine",
    350: "None",
    351: "Health Informatics",
    352: "Other Non-Clinical",
    353: "Complementary & Alternative Medicine",
    354: "Hospital Medicine",
    355: "Pharmacotherapy",
    356: "Oral & Maxillofacial Radiologist",
    357: "Oral & Maxillofacial Surgeon",
    358: "Oral Medicine",
    359: "Orthodontist",
    360: "Pedodontist",
    361: "Periodontist",
    362: "Prosthodontist",
    363: "Cosmetic Dentist",
    364: "Dental Public Health",
    365: "Endodontist",
    366: "General Dentist",
    367: "Oral & Maxillofacial Pathologist"
}